import ConfirmOptions from "./ConfirmOptions";
export default ConfirmOptions;
